const form_validation = require('../form_validation');

module.exports = function(){
  const $form = $('#email-form');

  function on_success () {
    $form.find('.newsletter__form').addClass('success')
  }

  form_validation.handle($form, on_success);
}